module.exports = __webpack_public_path__ + "static/img/tips-section2bb.6848df3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tips-section2bb.jpg
// module id = 210
// module chunks = 0